import clsx from 'clsx';
import React, { type PropsWithChildren } from 'react';

type PrimaryButtonV3Props = {
  onClick: VoidFunction;
  className?: string;
  disabled?: boolean;
};
export const PrimaryButtonV3 = ({
  children,
  onClick,
  className,
  disabled = false,
}: PropsWithChildren<PrimaryButtonV3Props>) => (
  <button
    type="button"
    disabled={disabled}
    onClick={onClick}
    className={clsx(
      'flex items-center',
      'h-f4 px-fone-half',
      'text-md',
      'bg-main text-negative',
      'hover:bg-negative hover:text-main hover:cursor-pointer',
      'transition-colors',
      className
    )}
  >
    {children}
  </button>
);
